
define('ldsh!modules/accounts/users/modal/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<!-- Modal Limites -->\n<div class="modal fade" id="modalLimitService" tabindex="-1" role="dialog" aria-labelledby="modalLangLabel" aria-hidden="true">\n  <div class="modal-dialog modal-dialog-services">\n    <div class="modal-content">\n      <div class="modal-header">\n        <div class="close-wrapper">\n          <a class="close" data-dismiss="modal">\n            <i class="ri-close-line"></i>\n          </a>\n        </div>\n      </div>\n      <div class="modal-body modal-body-services">\n        <div class="alert alert-danger" role="alert">\n          ';

            var userName = me.get('NAME')[0],
              serviceName = $.i18n.t("ACCOUNTS.COMPANIES.LBL_SERVICE_"+serviceId);
          ;
__p += ' <strong\n            class="i18n"\n            data-i18n="ACCOUNTS.USERS.LBL_SORRY"\n            data-i18n-options=\'{"userName": "' +
__e(userName ) +
'", "serviceName" : "' +
__e(serviceName ) +
'"}\'\n          > </strong>\n          <p></p>\n          <p><span\n            class="i18n"\n            data-i18n="[html]ACCOUNTS.USERS.LBL_PLAN_LIMIT"\n            data-i18n-options=\'{"limitMaxUsers": "' +
__e( dataLimitsService.maxUsers) +
'"}\'\n          ></span>\n          </p>\n        </div>\n\n        <p>\n          <strong\n            class="i18n"\n            data-i18n="[html]ACCOUNTS.COMPANIES.LBL_GET_THE_MAX_SERVICES"\n            data-i18n-options=\'{"serviceName": "' +
__e(serviceName ) +
'"}\'\n          > </strong>\n        </p>\n\n        ';
 if(serviceId == 2 || serviceId == 1 ){ ;
__p += '\n          <div class="flex align-center justify-center gap-12 mt48">\n            <button\n              id="cancel"\n              type="button"\n              data-dismiss="modal"\n              class="i18n btn--ghost e100"\n              data-i18n="ACCOUNTS.COMPANIES.LBL_NOT_NOW_THANKS"\n            ></button>\n            <button\n              id="expandAccountServices"\n              data-serviceId=\'' +
__e(serviceId ) +
'\'\n              class="i18n btn--primary e100 js-save"\n              data-i18n="ACCOUNTS.COMPANIES.LBL_SERVICES_PRICES"\n            ></button>\n          </div>\n        ';
 } ;
__p += '\n\n      </div>\n    </div>\n  </div>\n</div>\n';

}
return __p
};});

